import { render, staticRenderFns } from "./Form.Inconsistencies.vue?vue&type=template&id=38dbc672&scoped=true"
import script from "./Form.Inconsistencies.vue?vue&type=script&lang=js"
export * from "./Form.Inconsistencies.vue?vue&type=script&lang=js"
import style0 from "./Form.Inconsistencies.vue?vue&type=style&index=0&id=38dbc672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbc672",
  null
  
)

export default component.exports